export const richRecommendations = [
  // --- Business Setup in Dubai ---
  {
    category: "Business Setup in Dubai",
    q: "How to Start a Business in Dubai",
    overview: "Starting a business in Dubai is a straightforward process when guided by experts. It offers a strategic location, robust infrastructure, and tax advantages. BizWize simplifies your company formation from start to finish.",
    benefits: ["100% foreign ownership in most sectors", "0% personal income tax", "Access to global markets", "World-class infrastructure"],
    requirements: [
      { label: "Business Activity", desc: "Determine your exact commercial activity" },
      { label: "Jurisdiction", desc: "Choose between Mainland, Free Zone, or Offshore" },
      { label: "Trade Name", desc: "Submit proposed names for government approval" }
    ],
    costs: [
      { service: "Initial Approval Fees", cost: "AED 1,000 - 3,000" },
      { service: "BizWize Setup Package", cost: "Starting from AED 7,500" }
    ],
    timeline: [
      { step: "Name Approval", duration: "1-2 days" },
      { step: "License Issuance", duration: "3-5 days" }
    ]
  },
  {
    category: "Business Setup in Dubai",
    q: "What is a Trade License?",
    overview: "A Trade License is the official government document permitting you to conduct specific business activities in the UAE. Operating without one is strictly illegal.",
    benefits: ["Legal right to trade", "Ability to open corporate bank accounts", "Sponsor visas for employees"],
    requirements: [
      { label: "Application", desc: "Submit application to DED or Free Zone Authority" },
      { label: "Lease Agreement", desc: "Valid office lease (Ejari) or virtual desk" }
    ],
    costs: [
      { service: "Commercial License Fee", cost: "AED 10,000 - 20,000 / year" }
    ],
    timeline: [
      { step: "Issuance", duration: "1-3 days after document submission" }
    ]
  },
  {
    category: "Business Setup in Dubai",
    q: "Do I need a physical office?",
    overview: "While Mainland companies generally require a physical office space verified by Ejari, many Free Zones allow you to use a 'Flexi-desk' or virtual office to keep costs low.",
    benefits: ["Cost-effective startups", "Compliance with local regulations", "Professional business address"],
    requirements: [
      { label: "Ejari Certificate", desc: "Mandatory for Mainland physical offices" },
      { label: "Flexi-desk Lease", desc: "Acceptable for most Free Zone setups" }
    ],
    costs: [
      { service: "Flexi-desk", cost: "AED 5,000 - 15,000 / year" },
      { service: "Physical Office", cost: "AED 30,000+ / year" }
    ],
    timeline: [
      { step: "Office Registration", duration: "1-2 days" }
    ]
  },
  {
    category: "Business Setup in Dubai",
    q: "What is Ejari?",
    overview: "Ejari is Dubai's official electronic registration system for lease agreements. It protects the rights of both landlords and tenants and is required for trade license issuance.",
    benefits: ["Legal protection", "Required for trade license", "Required for employee visas"],
    requirements: [
      { label: "Tenancy Contract", desc: "Signed agreement between landlord and tenant" },
      { label: "DEWA Bill", desc: "Proof of electricity and water connection" }
    ],
    costs: [
      { service: "Ejari Registration", cost: "Approx. AED 220" }
    ],
    timeline: [
      { step: "Registration Process", duration: "Same day" }
    ]
  },
  {
    category: "Business Setup in Dubai",
    q: "Can I do business internationally?",
    overview: "Yes! Both Mainland and Free Zone companies can trade internationally. However, Free Zone companies cannot trade directly within the local UAE market without an agent.",
    benefits: ["Global reach", "No currency restrictions", "0% export taxes"],
    requirements: [
      { label: "Customs Code", desc: "Required for importing/exporting goods" }
    ],
    costs: [
      { service: "Customs Registration", cost: "Varies by jurisdiction" }
    ],
    timeline: [
      { step: "Customs Code Issuance", duration: "2-4 days" }
    ]
  },

  // --- Mainland Company Formation ---
  {
    category: "Mainland Company Formation",
    q: "Dubai Mainland Company Setup",
    overview: "A Mainland company (LLC) is licensed by the Dubai Department of Economic Development (DED). It allows you to trade anywhere in the UAE market and bid on government contracts.",
    benefits: ["100% Foreign Ownership (for most activities)", "No territorial restrictions inside UAE", "Ability to bid on government contracts", "Broader office location options"],
    requirements: [
      { label: "DED Approval", desc: "Initial approval from the DED" },
      { label: "MOA", desc: "Drafted and notarized Memorandum of Association" }
    ],
    costs: [
      { service: "DED License Fees", cost: "AED 15,000 - 25,000" },
      { service: "Market Fee", cost: "2.5% of annual office rent" }
    ],
    timeline: [
      { step: "Full Setup", duration: "5-7 working days" }
    ]
  },
  {
    category: "Mainland Company Formation",
    q: "Do I need a Local Sponsor?",
    overview: "Thanks to recent legal reforms, foreign investors can now own 100% of a Mainland company for over 1,000 commercial and industrial activities. A 51% local sponsor is only required for specific strategic sectors.",
    benefits: ["Full operational control", "100% profit retention", "Easier decision making"],
    requirements: [
      { label: "Activity Check", desc: "Verify if your activity is on the 100% ownership list" }
    ],
    costs: [
      { service: "Local Sponsor Fee (If applicable)", cost: "AED 10,000+ / year" }
    ],
    timeline: [
      { step: "Sponsor Agreement", duration: "1-2 days" }
    ]
  },
  {
    category: "Mainland Company Formation",
    q: "What is a Local Service Agent (LSA)?",
    overview: "For Professional licenses (like consultancies) on the Mainland, you own 100% of the company but must appoint a UAE National as a Local Service Agent to handle government liaisons.",
    benefits: ["100% ownership retained", "LSA has no management interference", "LSA has no profit share"],
    requirements: [
      { label: "LSA Agreement", desc: "Notarized agreement with a UAE National" }
    ],
    costs: [
      { service: "LSA Annual Fee", cost: "AED 5,000 - 15,000 / year" }
    ],
    timeline: [
      { step: "Agreement Drafting", duration: "1-2 days" }
    ]
  },
  {
    category: "Mainland Company Formation",
    q: "Mainland vs Free Zone",
    overview: "Mainland allows direct local trading and government contracts. Free Zones offer 0% corporate tax benefits on qualifying income and easier setups but restrict direct local trading.",
    benefits: ["Mainland: Local market access", "Free Zone: Tax benefits & ease of setup"],
    requirements: [
      { label: "Target Market", desc: "Determine if your clients are local or international" }
    ],
    costs: [
      { service: "Mainland Setup", cost: "Generally higher (requires physical office)" },
      { service: "Free Zone Setup", cost: "Generally lower (flexi-desk allowed)" }
    ],
    timeline: [
      { step: "Mainland", duration: "5-7 days" },
      { step: "Free Zone", duration: "2-4 days" }
    ]
  },
  {
    category: "Mainland Company Formation",
    q: "How to open a retail shop in Dubai?",
    overview: "To open a physical retail shop, restaurant, or salon, you MUST have a Mainland license. Free Zone licenses cannot be used for retail spaces in local malls or streets.",
    benefits: ["High foot traffic", "Direct B2C sales", "Prime locations across Dubai"],
    requirements: [
      { label: "Municipality Approval", desc: "Required for fit-outs and signage" },
      { label: "Ejari", desc: "Registered commercial lease" }
    ],
    costs: [
      { service: "Retail License", cost: "AED 20,000+" }
    ],
    timeline: [
      { step: "Approvals & Fit-out", duration: "2-6 weeks depending on design" }
    ]
  },

  // --- Free Zone Setup ---
  {
    category: "Free Zone Setup",
    q: "Dubai Free Zone Company Setup",
    overview: "Free Zones are special economic areas designed to boost international business. They offer simplified incorporation, tax incentives, and complete foreign ownership.",
    benefits: ["100% foreign ownership", "0% Corporate Tax on qualifying income", "No customs duties on imports/exports within the zone", "Fast incorporation process"],
    requirements: [
      { label: "Business Plan", desc: "Required by some premium Free Zones" },
      { label: "Passport Copies", desc: "For all shareholders and directors" }
    ],
    costs: [
      { service: "Basic Setup (No Visa)", cost: "AED 5,500 - 12,000" },
      { service: "Setup (1 Visa Allocation)", cost: "AED 12,000 - 18,000" }
    ],
    timeline: [
      { step: "Company Formation", duration: "2-4 working days" }
    ]
  },
  {
    category: "Free Zone Setup",
    q: "Which Free Zone is best?",
    overview: "The 'best' Free Zone depends entirely on your business activity. DMCC is great for commodities, IFZA is excellent for general services, and DDA is perfect for media and tech.",
    benefits: ["Tailored infrastructure", "Industry-specific networking", "Flexible office solutions"],
    requirements: [
      { label: "Activity Match", desc: "Ensure the Free Zone supports your specific activity" }
    ],
    costs: [
      { service: "Northern Emirates FZ", cost: "Cheaper (AED 5,500+)" },
      { service: "Dubai Premium FZ", cost: "More expensive (AED 15,000+)" }
    ],
    timeline: [
      { step: "Consultation & Selection", duration: "1 day" }
    ]
  },
  {
    category: "Free Zone Setup",
    q: "What is a Qualifying Free Zone Person?",
    overview: "Under the new UAE Corporate Tax law, a Qualifying Free Zone Person can benefit from a 0% tax rate on 'Qualifying Income' (usually from transactions with other Free Zone persons or specific international activities).",
    benefits: ["0% Corporate Tax rate", "Optimized profit margins"],
    requirements: [
      { label: "Economic Substance", desc: "Maintain adequate staff and assets in the UAE" },
      { label: "Audited Financials", desc: "Mandatory annual audits" }
    ],
    costs: [
      { service: "Audit Fees", cost: "AED 3,000 - 10,000 annually" }
    ],
    timeline: [
      { step: "Tax Assessment", duration: "Annually" }
    ]
  },
  {
    category: "Free Zone Setup",
    q: "Can a Free Zone company work with Mainland clients?",
    overview: "Legally, a Free Zone company cannot provide goods directly to the Mainland market. You must use a local distributor. For services, rules vary but usually require the work to be done within the Free Zone.",
    benefits: ["Access to UAE market via distributors", "Protection of Free Zone status"],
    requirements: [
      { label: "Distributor Agreement", desc: "Contract with a Mainland logistics/trading agent" }
    ],
    costs: [
      { service: "Distributor Margins", cost: "Varies by contract" }
    ],
    timeline: [
      { step: "Agreement Setup", duration: "1-2 weeks" }
    ]
  },
  {
    category: "Free Zone Setup",
    q: "Is auditing mandatory for Free Zones?",
    overview: "It depends on the specific Free Zone authority. DMCC and JAFZA strictly require annual audited financials, while others like IFZA or Shams may not request them for license renewal.",
    benefits: ["Financial transparency", "Easier bank loan approvals", "Corporate Tax compliance"],
    requirements: [
      { label: "Approved Auditor", desc: "Must use an auditor registered with the Free Zone" }
    ],
    costs: [
      { service: "Annual Audit", cost: "AED 3,000 - 8,000" }
    ],
    timeline: [
      { step: "Audit Process", duration: "2-4 weeks after financial year end" }
    ]
  },

  // --- Visa Services ---
  {
    category: "Visa Services",
    q: "UAE Residence Visa Process",
    overview: "Obtaining a UAE Residence Visa is a multi-step process that ensures you are legally permitted to live and work in the country. BizWize handles all typing, medical bookings, and Emirates ID processing.",
    benefits: ["Legal residency", "Access to healthcare & schools", "Ability to open personal bank accounts"],
    requirements: [
      { label: "Entry Permit", desc: "E-visa required to enter or change status" },
      { label: "Medical Fitness Test", desc: "Blood test and chest X-ray" },
      { label: "Emirates ID Biometrics", desc: "Fingerprinting at an ICA center" }
    ],
    costs: [
      { service: "Standard Visa Cost", cost: "AED 3,000 - 6,000" }
    ],
    timeline: [
      { step: "Complete Process", duration: "5-7 working days" }
    ]
  },
  {
    category: "Visa Services",
    q: "What is an Investor Visa?",
    overview: "An Investor (or Partner) Visa is granted to foreign nationals who own shares in a UAE Mainland or Free Zone company. It is typically valid for 2 years.",
    benefits: ["Long-term residency", "No age limit for investors", "Easy family sponsorship"],
    requirements: [
      { label: "Trade License", desc: "Your name must be on the license or MOA" },
      { label: "Immigration Establishment Card", desc: "Company registration with immigration" }
    ],
    costs: [
      { service: "Investor Visa Fees", cost: "AED 4,000 - 7,000" }
    ],
    timeline: [
      { step: "Issuance", duration: "5-7 days" }
    ]
  },
  {
    category: "Visa Services",
    q: "Can I sponsor my family?",
    overview: "Yes! Once you hold a valid UAE Residence Visa and meet the minimum salary requirement (usually AED 4,000+), you can sponsor your spouse, children, and parents.",
    benefits: ["Family unity", "Dependents get Emirates IDs", "Access to local schools"],
    requirements: [
      { label: "Ejari/Tenancy", desc: "Proof of adequate housing" },
      { label: "Attested Certificates", desc: "Marriage and birth certificates must be attested" }
    ],
    costs: [
      { service: "Dependent Visa", cost: "Approx. AED 3,000 per person" }
    ],
    timeline: [
      { step: "Family Visa Processing", duration: "5-10 days" }
    ]
  },
  {
    category: "Visa Services",
    q: "What is a Freelance Visa?",
    overview: "A Freelance Visa allows individuals to operate as independent contractors. It is a cost-effective alternative to a full company setup for solo professionals in media, tech, or education.",
    benefits: ["Low setup cost", "Legal residency", "Flexibility to work with multiple clients"],
    requirements: [
      { label: "Portfolio/Degree", desc: "Proof of expertise in your field" },
      { label: "NOC", desc: "If you are currently employed in the UAE" }
    ],
    costs: [
      { service: "Freelance Permit + Visa", cost: "AED 7,500 - 15,000" }
    ],
    timeline: [
      { step: "Permit & Visa", duration: "7-10 days" }
    ]
  },
  {
    category: "Visa Services",
    q: "Medical Fitness Test Details",
    overview: "The medical test is a mandatory health screening for all new residents and renewals. It checks for communicable diseases like HIV, Hepatitis B, and Tuberculosis.",
    benefits: ["Public health safety", "Mandatory for Emirates ID"],
    requirements: [
      { label: "Passport Copy", desc: "Required at the clinic" },
      { label: "Entry Permit", desc: "Must be issued prior to testing" }
    ],
    costs: [
      { service: "Standard Test", cost: "AED 320" },
      { service: "VIP (2-hour results)", cost: "AED 750" }
    ],
    timeline: [
      { step: "Results", duration: "2 - 24 hours" }
    ]
  },

  // --- Bank Account Opening ---
  {
    category: "Bank Account Opening",
    q: "Corporate Bank Account Opening",
    overview: "Opening a corporate bank account in the UAE requires passing strict KYC (Know Your Customer) and AML (Anti-Money Laundering) compliance checks. BizWize offers guaranteed assistance.",
    benefits: ["Secure transactions", "Global currency support", "Access to business credit"],
    requirements: [
      { label: "Company Documents", desc: "Trade License, MOA, Share Certificate" },
      { label: "Personal Documents", desc: "Passport, Emirates ID, Visa of shareholders" },
      { label: "Business Plan", desc: "Proof of business model and suppliers/clients" }
    ],
    costs: [
      { service: "BizWize Banking Assistance", cost: "Included in premium packages" }
    ],
    timeline: [
      { step: "Digital Banks (e.g., Wio)", duration: "2-5 days" },
      { step: "Traditional Banks", duration: "2-4 weeks" }
    ]
  },
  {
    category: "Bank Account Opening",
    q: "Which banks are best for startups?",
    overview: "For new startups and Free Zone companies without large physical offices, digital-first banks are the best option due to faster approvals and lower requirements.",
    benefits: ["Zero/Low minimum balance", "Fast digital onboarding", "Modern mobile apps"],
    requirements: [
      { label: "Emirates ID", desc: "Usually required for digital onboarding" }
    ],
    costs: [
      { service: "Wio Business", cost: "AED 99 / month" },
      { service: "Mashreq NeoBiz", cost: "AED 200 / month" }
    ],
    timeline: [
      { step: "Approval", duration: "48-72 hours" }
    ]
  },
  {
    category: "Bank Account Opening",
    q: "Do I need a minimum balance?",
    overview: "Traditional banks (like Emirates NBD or ADCB) typically require an average monthly minimum balance ranging from AED 50,000 to AED 500,000. Digital banks often have zero minimum balance requirements.",
    benefits: ["Digital banks preserve startup capital", "Premium banking offers relationship managers"],
    requirements: [
      { label: "Initial Deposit", desc: "Must be transferred upon account activation" }
    ],
    costs: [
      { service: "Fall-below fee", cost: "AED 250 - 500 / month if balance drops" }
    ],
    timeline: [
      { step: "Initial Deposit Window", duration: "Usually 30 days post-opening" }
    ]
  },
  {
    category: "Bank Account Opening",
    q: "Why do banks reject applications?",
    overview: "Banks reject applications if the business activity is high-risk (e.g., crypto, general trading without proof), if the founders lack experience, or if the source of funds is unclear.",
    benefits: ["Compliance ensures global banking access", "Protects the UAE financial system"],
    requirements: [
      { label: "Strong CV", desc: "Proof of founder's industry experience" },
      { label: "6-Month Bank Statement", desc: "Personal statements showing clean history" }
    ],
    costs: [
      { service: "Application Fee", cost: "Usually Free" }
    ],
    timeline: [
      { step: "Compliance Review", duration: "1-3 weeks" }
    ]
  },
  {
    category: "Bank Account Opening",
    q: "Can I open an account without an Emirates ID?",
    overview: "While extremely difficult, some traditional banks allow non-resident corporate accounts. However, having an Emirates ID makes the process 10x faster and easier.",
    benefits: ["Emirates ID unlocks digital banking", "Higher approval rates"],
    requirements: [
      { label: "Non-Resident Account", desc: "Requires high initial deposits (AED 500k+)" }
    ],
    costs: [
      { service: "Non-Resident Fees", cost: "Varies heavily" }
    ],
    timeline: [
      { step: "Non-Resident Approval", duration: "1-2 months" }
    ]
  },

  // --- Trade License Renewal ---
  {
    category: "Trade License Renewal",
    q: "How to renew a Trade License?",
    overview: "Trade licenses in the UAE must be renewed annually. Delays in renewal result in monthly government fines and potential freezing of corporate bank accounts.",
    benefits: ["Continuous legal compliance", "Avoidance of late fines", "Uninterrupted banking"],
    requirements: [
      { label: "Valid Ejari", desc: "Updated lease agreement (for Mainland)" },
      { label: "Audit Report", desc: "If required by your Free Zone" }
    ],
    costs: [
      { service: "Renewal Fees", cost: "Usually matches initial license fee" },
      { service: "Late Fines", cost: "AED 200+ per month" }
    ],
    timeline: [
      { step: "Renewal Process", duration: "1-2 days" }
    ]
  },
  {
    category: "Trade License Renewal",
    q: "What happens if I don't renew?",
    overview: "Failing to renew your license will incur accumulating monthly fines. Eventually, your company will be blocked by immigration (preventing visa issuance) and your bank accounts will be frozen.",
    benefits: ["Timely renewal prevents operational disaster"],
    requirements: [
      { label: "Clear Fines", desc: "All pending fines must be paid before renewal" }
    ],
    costs: [
      { service: "DED Fines", cost: "Can exceed AED 5,000 if left for a year" }
    ],
    timeline: [
      { step: "Grace Period", duration: "Usually 30 days post-expiry" }
    ]
  },
  {
    category: "Trade License Renewal",
    q: "Can BizWize handle my renewal?",
    overview: "Absolutely. BizWize offers dedicated license renewal services. We remind you 30 days in advance, process the paperwork, and deliver the renewed license directly to you.",
    benefits: ["Zero hassle", "No missed deadlines", "Expert handling of Ejari updates"],
    requirements: [
      { label: "Authorization", desc: "Signed NOC for BizWize to act on your behalf" }
    ],
    costs: [
      { service: "BizWize Service Fee", cost: "AED 1,000 - 2,000" }
    ],
    timeline: [
      { step: "BizWize Processing", duration: "Same day" }
    ]
  },
  {
    category: "Trade License Renewal",
    q: "Do I need to renew my Establishment Card?",
    overview: "Yes, the Immigration Establishment Card must be renewed annually (or bi-annually) along with the Trade License. Without it, you cannot apply for or renew employee visas.",
    benefits: ["Allows continuous visa processing"],
    requirements: [
      { label: "Renewed License", desc: "Must be presented to immigration" }
    ],
    costs: [
      { service: "Establishment Card Renewal", cost: "Approx. AED 500 - 1,000" }
    ],
    timeline: [
      { step: "Card Update", duration: "1-2 days" }
    ]
  },
  {
    category: "Trade License Renewal",
    q: "How to cancel a Trade License?",
    overview: "If you wish to close your business, you must officially liquidate and cancel the license. Simply letting it expire will result in massive fines and a travel ban.",
    benefits: ["Clean legal exit", "No lingering debt or fines", "Clearance from Ministry of Labor"],
    requirements: [
      { label: "Clearance Certificates", desc: "From DEWA, Etisalat, and Landlord" },
      { label: "Liquidator Report", desc: "Required for LLCs and FZCOs" }
    ],
    costs: [
      { service: "Cancellation Fees", cost: "AED 3,000 - 8,000" }
    ],
    timeline: [
      { step: "Liquidation Process", duration: "45-60 days" }
    ]
  },

  // --- PRO Services ---
  {
    category: "PRO Services",
    q: "What are PRO Services?",
    overview: "Public Relations Officer (PRO) services involve handling all government liaison tasks—like visa processing, document attestation, and license amendments—so you can focus on running your business.",
    benefits: ["Saves time and money", "Ensures 100% legal compliance", "Eliminates typing center queues"],
    requirements: [
      { label: "Corporate PRO Contract", desc: "Annual agreement with BizWize" }
    ],
    costs: [
      { service: "Annual PRO Retainer", cost: "AED 10,000 - 25,000 / year" },
      { service: "Per-Task PRO", cost: "AED 500 - 1,500 / task" }
    ],
    timeline: [
      { step: "Task Execution", duration: "Usually 24-48 hours" }
    ]
  },
  {
    category: "PRO Services",
    q: "What is document attestation?",
    overview: "Foreign documents (like degrees or marriage certificates) must be legally authenticated by the UAE Embassy in the home country and the MOFA in the UAE before they can be used for visas.",
    benefits: ["Validates foreign documents for UAE legal use"],
    requirements: [
      { label: "Original Document", desc: "Must be physically presented" }
    ],
    costs: [
      { service: "MOFA Attestation", cost: "Approx. AED 150 per document" }
    ],
    timeline: [
      { step: "Full Attestation", duration: "1-3 weeks depending on country" }
    ]
  },
  {
    category: "PRO Services",
    q: "How to get a Maid Visa?",
    overview: "Residents who meet a specific salary threshold can sponsor domestic helpers. Our PRO team handles the intricate typing, medical, and contract typing required by Tadbeer.",
    benefits: ["Legal sponsorship of domestic help", "Peace of mind"],
    requirements: [
      { label: "Minimum Salary", desc: "Sponsor must earn AED 25,000+ (varies)" },
      { label: "Tadbeer Contract", desc: "Official domestic worker contract" }
    ],
    costs: [
      { service: "Maid Visa Setup", cost: "AED 8,000 - 12,000" }
    ],
    timeline: [
      { step: "Visa Processing", duration: "7-10 days" }
    ]
  },
  {
    category: "PRO Services",
    q: "How to amend a Trade License?",
    overview: "If you need to change your company name, add a new business activity, or change shareholders, a formal license amendment must be processed through the DED or Free Zone.",
    benefits: ["Allows business expansion", "Updates legal shareholding"],
    requirements: [
      { label: "Board Resolution", desc: "Signed agreement by all current shareholders" },
      { label: "MOA Amendment", desc: "Notarized update to the constitution" }
    ],
    costs: [
      { service: "Amendment Fees", cost: "AED 2,000 - 5,000+" }
    ],
    timeline: [
      { step: "Amendment Processing", duration: "3-5 days" }
    ]
  },
  {
    category: "PRO Services",
    q: "Do I need an internal PRO?",
    overview: "Hiring a full-time internal PRO is expensive (salary, visa, insurance). Outsourcing to BizWize gives you an entire team of experts for a fraction of the cost of one employee.",
    benefits: ["No employee overhead costs", "Access to experts in all jurisdictions", "Zero downtime for sick leave"],
    requirements: [
      { label: "Outsourcing Decision", desc: "Choose BizWize Corporate PRO package" }
    ],
    costs: [
      { service: "Outsourced PRO vs Internal", cost: "Saves up to 60% annually" }
    ],
    timeline: [
      { step: "Onboarding", duration: "Immediate" }
    ]
  },

  // --- VAT & Accounting ---
  {
    category: "VAT & Accounting",
    q: "What is VAT in the UAE?",
    overview: "Value Added Tax (VAT) is a 5% indirect tax levied on the consumption of most goods and services in the UAE. Businesses collect it on behalf of the Federal Tax Authority (FTA).",
    benefits: ["Aligns UAE with global tax standards", "Provides infrastructure revenue"],
    requirements: [
      { label: "Tax Invoices", desc: "Must issue FTA-compliant invoices" },
      { label: "Record Keeping", desc: "Keep financial records for 5 years" }
    ],
    costs: [
      { service: "Standard VAT Rate", cost: "5%" },
      { service: "Accounting Software", cost: "AED 1,000 - 3,000 / year" }
    ],
    timeline: [
      { step: "VAT Return Filing", duration: "Quarterly (usually)" }
    ]
  },
  {
    category: "VAT & Accounting",
    q: "When must I register for VAT?",
    overview: "VAT registration is MANDATORY if your taxable supplies/imports exceed AED 375,000 over a 12-month period. It is VOLUNTARY if they exceed AED 187,500.",
    benefits: ["Voluntary registration allows reclaiming input VAT early"],
    requirements: [
      { label: "Financial Proof", desc: "Invoices/audits proving the threshold is met" }
    ],
    costs: [
      { service: "Late Registration Fine", cost: "AED 10,000" }
    ],
    timeline: [
      { step: "FTA Approval", duration: "2-4 weeks" }
    ]
  },
  {
    category: "VAT & Accounting",
    q: "Do I need to hire an accountant?",
    overview: "While not legally required to hire an in-house accountant, maintaining accurate books is mandatory. Outsourcing bookkeeping to BizWize ensures FTA compliance without the high salary costs.",
    benefits: ["Error-free VAT filings", "Avoidance of FTA fines", "Clear financial visibility"],
    requirements: [
      { label: "Monthly Bank Statements", desc: "Must be provided to your bookkeeper" },
      { label: "Expense Receipts", desc: "Required to claim input VAT" }
    ],
    costs: [
      { service: "Outsourced Bookkeeping", cost: "Starting from AED 1,000 / month" }
    ],
    timeline: [
      { step: "Monthly Reconciliation", duration: "Ongoing" }
    ]
  },

  // --- Corporate Tax ---
  {
    category: "Corporate Tax",
    q: "What is UAE Corporate Tax?",
    overview: "The UAE introduced a Corporate Tax rate of 9% on taxable net profits exceeding AED 375,000, effective for financial years starting on or after June 1, 2023.",
    benefits: ["Keeps UAE globally competitive", "0% rate for profits under AED 375k"],
    requirements: [
      { label: "CT Registration", desc: "Mandatory for ALL companies (even Free Zones)" },
      { label: "Financial Year", desc: "Determine your tax period" }
    ],
    costs: [
      { service: "Corporate Tax Rate", cost: "9% on profits > AED 375k" }
    ],
    timeline: [
      { step: "Tax Return Filing", duration: "Within 9 months of financial year-end" }
    ]
  },
  {
    category: "Corporate Tax",
    q: "Are Free Zones exempt from Corporate Tax?",
    overview: "Qualifying Free Zone Persons (QFZP) can benefit from a 0% tax rate, BUT only on 'Qualifying Income' (e.g., manufacturing, or trading with other Free Zone entities). All other income is taxed at 9%.",
    benefits: ["Massive tax savings for logistics and manufacturing"],
    requirements: [
      { label: "Audited Financials", desc: "MANDATORY to claim the 0% exemption" },
      { label: "Economic Substance", desc: "Must prove adequate presence in the FZ" }
    ],
    costs: [
      { service: "Audit Fees", cost: "AED 5,000+" }
    ],
    timeline: [
      { step: "Annual Audit", duration: "Required yearly" }
    ]
  },
  {
    category: "Corporate Tax",
    q: "What happens if I don't register for Corporate Tax?",
    overview: "Failure to register for Corporate Tax by your specific FTA-mandated deadline will result in an immediate AED 10,000 administrative penalty.",
    benefits: ["Registration ensures compliance"],
    requirements: [
      { label: "EmaraTax Portal", desc: "Registration is done via the FTA portal" }
    ],
    costs: [
      { service: "Late Registration Fine", cost: "AED 10,000" }
    ],
    timeline: [
      { step: "Registration Deadline", duration: "Varies by license issuance month" }
    ]
  },

  // --- Golden Visa ---
  {
    category: "Golden Visa",
    q: "How to get a UAE Golden Visa",
    overview: "The UAE Golden Visa is an exclusive long-term residency program (10 years) that allows foreigners to live, work, and study in the UAE without needing a national sponsor.",
    benefits: ["10-year renewable residency", "No limit on time spent outside UAE", "Sponsor family seamlessly", "No employer sponsorship needed"],
    requirements: [
      { label: "Investor Route", desc: "AED 2 Million in property or business investment" },
      { label: "Talent Route", desc: "Doctors, scientists, outstanding students, creatives" },
      { label: "Health Insurance", desc: "Comprehensive UAE medical coverage required" }
    ],
    costs: [
      { service: "Golden Visa Processing Fee", cost: "AED 3,000 - 5,000" },
      { service: "Medical & Emirates ID", cost: "AED 1,500 - 2,500" }
    ],
    timeline: [
      { step: "Nomination Approval", duration: "7-14 days" },
      { step: "Visa Issuance", duration: "3-5 days" }
    ]
  },
  {
    category: "Golden Visa",
    q: "Property Investment Golden Visa",
    overview: "You can obtain a 10-year Golden Visa by purchasing real estate in the UAE worth at least AED 2 Million. The property can be ready or off-plan (from approved developers).",
    benefits: ["High ROI on Dubai property", "10-year residency included"],
    requirements: [
      { label: "Title Deed", desc: "Proof of ownership worth AED 2M+" },
      { label: "Mortgage Rule", desc: "If mortgaged, bank NOC is required" }
    ],
    costs: [
      { service: "DLD Fees", cost: "4% of property value" }
    ],
    timeline: [
      { step: "Property Purchase", duration: "2-4 weeks" },
      { step: "Visa Processing", duration: "1-2 weeks" }
    ]
  },
  {
    category: "Golden Visa",
    q: "Can I sponsor my parents on a Golden Visa?",
    overview: "Yes! One of the major benefits of the Golden Visa is the ability to sponsor your parents for a 10-year visa, without having to place large deposits as required by standard visas.",
    benefits: ["10-year visas for parents", "No deposit required"],
    requirements: [
      { label: "Birth Certificate", desc: "Attested proof of relationship" }
    ],
    costs: [
      { service: "Parent Visa Processing", cost: "Approx. AED 3,500 per parent" }
    ],
    timeline: [
      { step: "Processing", duration: "5-7 days" }
    ]
  },

  // --- Business Costs and Timelines ---
  {
    category: "Business Costs and Timelines",
    q: "What are the hidden costs of starting a business?",
    overview: "Many setup agencies quote a low 'starting' price. Hidden costs often include establishment cards, e-channel registrations, visa allocation fees, and mandatory medical/Emirates ID typing fees.",
    benefits: ["BizWize offers 100% transparent pricing"],
    requirements: [
      { label: "Ask for an All-Inclusive Quote", desc: "Ensure visas and establishment cards are included" }
    ],
    costs: [
      { service: "E-Channel Fee", cost: "AED 2,000+ (often hidden)" },
      { service: "Establishment Card", cost: "AED 500 - 1,500 (often hidden)" }
    ],
    timeline: [
      { step: "Quote Review", duration: "Immediate" }
    ]
  },
  {
    category: "Business Costs and Timelines",
    q: "How fast can I get my company set up?",
    overview: "If all your documents are prepared, a standard Free Zone company can be incorporated in as little as 48 hours. Visas and bank accounts take additional time.",
    benefits: ["Fast market entry", "Digital incorporation available"],
    requirements: [
      { label: "Document Readiness", desc: "Have passport and visa copies ready" }
    ],
    costs: [
      { service: "VIP Express Service", cost: "Available at a premium" }
    ],
    timeline: [
      { step: "License", duration: "2-4 Days" },
      { step: "Visa", duration: "5-7 Days" },
      { step: "Banking", duration: "2-4 Weeks" }
    ]
  }
];
